import React from "react"
import Style from "./NutritionCalculatorSearchInputStyle.module.styl"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch"
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes"
import translate, { keys } from "../../../../../translation/translator"
const NutritionCalculatorSearchInput = ({
  searchedProduct,
  handleInput,
  handleSendSearchRequest,
  handleClear,
  locale,
}) => {
  const ph = translate(keys.NUTRITION_INPUT, locale)
  return (
    <div className={Style.input_holder}>
      {" "}
      <input
        className={Style.search_input}
        placeholder={ph}
        value={searchedProduct}
        onChange={handleInput}
        onKeyDown={handleSendSearchRequest}
      />
      <FontAwesomeIcon icon={faSearch} />
      {searchedProduct && (
        <FontAwesomeIcon
          icon={faTimes}
          className={Style.clear}
          onClick={handleClear}
        />
      )}
    </div>
  )
}

export default NutritionCalculatorSearchInput
